import React, {useEffect, useState} from 'react';
import {Button} from "antd";

const HandleSubmitButton = ({onClick, loading = false}) => {
    const [loadingStatus, setLoadingStatus] = useState(loading)
    useEffect(() => {
        setLoadingStatus(loading)
    }, [loading]);
    return (

        <Button loading={loadingStatus} className='defBtn blueBtn' onClick={onClick}>اعمال</Button>

    );
};

export default HandleSubmitButton;